import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectHomeVehicles } from "../../redux/selector";
import { useStyles } from "./styles";

const fallbackVehicles = Array.from({ length: 5 }).map((_, index) => ({
  id: index + 1,
  name: "Volvo FH 16",
  chassisNumber: "VLV-99283-X",
  arrivalDate: "01/04/2026",
  workOrder: "WO-8901",
}));

const VehicleInYard = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const reduxVehicles = useSelector(selectHomeVehicles);

  const vehicles =
    reduxVehicles && reduxVehicles.length > 0
      ? reduxVehicles
      : fallbackVehicles;

  return (
    <Box>
      <Typography className={styles.sectionTitle}>
        {t("HOME.VEHICLES_IN_YARD")}
      </Typography>

      <Box className={styles.grid}>
        {vehicles.map((vehicle) => (
          <Box key={vehicle.id} className={styles.card}>
            <Box className={styles.cardHeader}>
              <Box className={styles.vehicleIcon}>
                <LocalShippingIcon />
              </Box>

              <Typography className={styles.vehicleName}>
                {vehicle.name}
              </Typography>
            </Box>

            <Box className={styles.divider} />

            <Box className={styles.row}>
              <Typography className={styles.label}>
                {t("HOME.CHASSIS_NUMBER")}
              </Typography>

              <Typography className={styles.value}>
                {vehicle.chassisNumber}
              </Typography>
            </Box>

            <Box className={styles.row}>
              <Typography className={styles.label}>
                {t("HOME.ARRIVAL_DATE")}
              </Typography>

              <Typography className={styles.value}>
                {vehicle.arrivalDate}
              </Typography>
            </Box>

            <Box className={styles.row}>
              <Typography className={styles.label}>
                {t("HOME.WORK_ORDER_LINK")}
              </Typography>

              <Typography className={styles.link}>
                {vehicle.workOrder}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default VehicleInYard;